// Angular imports
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

// 3rd party imports
import { DxValidationGroupComponent } from 'devextreme-angular';

// CC-Common imports
import { IconConstants } from '@therealmanage/ciranet-ui-common';
import { RecaptchaBaseComponent } from '../../_base/recaptcha-base.component';

// Service imports
import { EnvironmentConfigService } from '../../_services/environment-config.service';
import { ServerErrorService } from '../../_services/shared-services/server-error.service';
import { ScreenService } from '../../_services/shared-services/screen.service';
import { UserService } from '../../_services/data-services/user.service';

// Model imports
import { ForgotUserNameParameterDto } from '../../_models/forgot-user-name-parameter-dto';
import { ResultStatusDto } from '../../_models/result-status-dto';

// CC-Common imports
import { RxjsUtils } from '@therealmanage/ciranet-ui-common';

@Component({
  selector: 'app-retrieve-username-or-validate-email',
  templateUrl: './retrieve-username-or-validate-email.component.html',
  styleUrls: ['./retrieve-username-or-validate-email.component.scss'],
  standalone: false
})
export class RetrieveUsernameOrValidateEmailComponent
  extends RecaptchaBaseComponent
  implements OnInit
{
  @ViewChild('validatorRetrieveUserName', { static: false })
  validatorRetrieveUserName: DxValidationGroupComponent;

  @Input() isEmbedded = false;
  @Output() closePanel = new EventEmitter<void>();

  isSmallScreen = false;
  email = '';
  loadingVisible = false;
  errorMessage = '';
  isEmailSent = false;
  showErrorMessage = false;

  backToLoginIcon = IconConstants.BACK_TO_LOGIN;
  resetIcon = IconConstants.RESET;

  constructor(
    private router: Router,
    private userService: UserService,
    private screenService: ScreenService,
    protected override errorService: ServerErrorService,
    protected override envConfig: EnvironmentConfigService
  ) {
    super(errorService, envConfig);
  }

  ngOnInit() {
    this.updateScreenSize();
    RxjsUtils.safeSubscribe(this.screenService.changed, () =>
      this.updateScreenSize()
    );
  }

  btnRetrieveUserName(event): void {
    // Clear any previous error messages
    this.showErrorMessage = false;
    this.errorMessage = '';

    const validator = this.validatorRetrieveUserName.instance.validate();

    if (validator.isValid && this.isValidRecaptcha()) {
      this.loadingVisible = true;
      const dto = new ForgotUserNameParameterDto();
      dto.email = this.email;
      dto.recaptchaToken = this.recaptchaToken;

      RxjsUtils.safeSubscribe(
        this.userService.sendForgotUsernameEmail(dto),
        (data: ResultStatusDto) => {
          this.resetRecaptcha();
          this.loadingVisible = false;
          if (data.isSuccess) {
            // Show inline success message instead of popup
            this.isEmailSent = true;
            this.showErrorMessage = false;
            this.errorMessage = '';
          } else {
            // Show inline error message instead of popup
            this.showErrorMessage = true;
            this.errorMessage =
              "Sorry, we couldn't validate your email. Please try again or contact customer support.";
          }
        },
        (error: HttpErrorResponse) => {
          this.resetRecaptcha();
          this.loadingVisible = false;
          // Show inline error message instead of popup
          this.showErrorMessage = true;
          this.errorMessage =
            "Sorry, we couldn't validate your email. Please try again or contact customer support.";
        }
      );
    }
  }

  btnBackToLogin(event): void {
    if (this.isEmbedded) {
      this.closePanel.emit();
    } else {
      this.router.navigate(['user', 'login']);
    }
  }

  private updateScreenSize(): void {
    this.isSmallScreen = this.screenService.isSmallScreen();
  }
}
